// MAJLIS-168 (the consultant's string rule of 2026-10-05): a NEW key is in every catalogue - English and Arabic by hand,
// the 28 others generated (web/tools/i18n/generate.ts --keys, at 0 seats) and back-translated - but the interface shows
// it only after the consultant's verdict on those translations. Until then each pending key is listed here with what the
// interface shows in its place: an existing key (already ruled on in every language), or null for nothing at all.
// WIRING a key after its verdict is deleting its line here; nothing else changes (pending.test.ts holds every pending key
// to a real key in every catalogue, and every use in a component to `shown`).
import type { StringKey } from "./catalogues/en";

export const PENDING_KEYS: Partial<Record<StringKey, StringKey | null>> = {
  // MAJLIS-168's four (modeNewShort, modeExistingShort, listenHintTap, summaryFailedBody) were WIRED after the
  // consultant's verdicts of 2026-10-05 (docs/i18n/new-keys-2026-10-05.md).
  // MAJLIS-176's 21 (the admin screens) were WIRED after the consultant's verdicts of 2026-10-06
  // (docs/i18n/new-keys-2026-10-06.md). The mechanism stays for later keys.
};

/** The key the interface shows for `key` today: itself once wired, its stand-in while pending (null: show nothing). */
export function shown(key: StringKey): StringKey | null {
  return key in PENDING_KEYS ? (PENDING_KEYS[key] ?? null) : key;
}
